
import ViewHeader from "@/components/ViewHeader.vue";
import { useStore } from "@/store";
import { defineComponent, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "SelectPriceType",
  props: {
    isClub: {
      type: Boolean,
      default: false,
    },
  },
  components: { ViewHeader },
  setup(props, { emit }) {
    const store = useStore();
    const router = useRouter();

    const priceTypes = computed(() =>
      store.state.priceTypes.map((x) => x).sort((a, b) => a.id - b.id)
    );
    const currentLanguageId = computed(() => store.state.currentLanguageId);
    const { t } = useI18n();

    function selectPriceType(id: number) {
      store.commit("clearOrder");
      store.dispatch("setOrderPriceType", id);
      if (props.isClub) {
        emit("onSelectOrderPriceType");
        return;
      }
      router.push({ name: "select-products" });
    }

    function isPriceTypeAvailable(id: number) {
      return priceTypes.value.some((x) => x.id === id && x.available);
    }

    return {
      t,
      priceTypes,
      selectPriceType,
      isPriceTypeAvailable,
      currentLanguageId,
    };
  },
});
